//request.js
import { createAxios } from 'xmgoing-server';
import { notification as Notification } from 'ant-design-vue';
import {StorageUtils} from 'xmgoing-utils';
import { useI18n } from '@/hooks/web/useI18n';

const { t } = useI18n();
const service = createAxios({
  baseURL: '/api', // api的base_url
  withCredentials: true,
  timeout: 30000, // 请求超时时间
});

async function exceptionHandler(error: any) {
  const { status, data } = error?.response ?? {};
  const { exceptionMessage } = error?.config ?? {};
  const isNoMessage = error?.config?.headers?.noMessage ?? false; //请求头自定义noMessage,则不提示

  let message = data?.error_description ?? exceptionMessage ?? data?.message ?? data?.msg;

  if (status === 401) {
    const msg = data?.error; //-->解决token死循环问题

    const refreshTokenError = ['grant_type=refresh_token', 'unauthorized', 'invalid_token'];
    if (refreshTokenError.includes(msg)) {
      return Promise.reject(error);
    }

    message = '';

    return Promise.reject(error);
  } else if (status === 403) {
    message = message ?? t('component.msg.用户权限异常, 请联系系统管理人员');
  } else if (status >= 500) {
    message =
      message ??
      t('component.msg.服务端错误, 状态码') +
        `: ${status}，` +
        t('component.msg.请联系系统管理人员');
  } else {
    message =
      message ??
      t('component.msg.未知的异常, 状态码') +
        `: ${status}，` +
        t('component.msg.请联系系统管理人员');
  }

  if (!isNoMessage) {
    message &&
      Notification.error({
        message: t('component.msg.操作失败'),
        description: message,
      });
  } else {
    // 如果是isNoMessage，表示只是没有数据而非异常
    return Promise.resolve(error.response);
  }

  return Promise.reject(error);
}

function requestHandler(config: any) {
  const menuId=sessionStorage.getItem('curMenuId');
  const accessToken = StorageUtils.getSessionItem("sessionId");
  accessToken && (config.headers['Blade-Auth'] = `bearer ${accessToken}`);
  menuId && (config.headers['Menu-Id'] = `${menuId}`);
  return config;
}

//-->错误拦截
function responseHandler(response: any) {
  const isNoMessage = !response.config.headers.noMessage; //请求头自定义noMessage,则不提示

  if (response.data.code && response.data.code !== 200 && isNoMessage) {
    Notification.warning({
      message: t('component.msg.操作失败'),
      description: response?.data?.msg ?? '',
    });
    return Promise.reject(response);
  }

  return response;
}

service.interceptors.request.use(requestHandler, exceptionHandler);

service.interceptors.response.use(responseHandler, exceptionHandler);

export default service;
export const axiosHelpers = service.helpers;
